import type { IconData } from '@stacksjs/iconify-core'

export const fridge: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M376 16H136a48.054 48.054 0 0 0-48 48v400a32.036 32.036 0 0 0 32 32h272a32.036 32.036 0 0 0 32-32V64a48.054 48.054 0 0 0-48-48m16 448H120V240h272Zm0-256H120V64a16.02 16.02 0 0 1 16-16h240a16.02 16.02 0 0 1 16 16Z\"/><path fill=\"currentColor\" d=\"M144 280h32v96h-32zm0-176h32v64h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fridge
